import { render, staticRenderFns } from "./AuthorizationForm.vue?vue&type=template&id=16f8e44e&"
import script from "./AuthorizationForm.vue?vue&type=script&lang=js&"
export * from "./AuthorizationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports